/**
 * Responsive design breakpoints — mirror of $BREAKPOINT_* in _breakpoints.scss.
 * Keep in sync with SCSS when changing values.
 */
export const BREAKPOINT_MD = 810;   // tablets
export const BREAKPOINT_XL = 1200;  // desktops

// Legacy aliases
export const RESPONSIVE_SCREEN_WIDTH = BREAKPOINT_MD;
